<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.groups'),
                        href: meta.links.group_index,
                    },
                    {
                        name: group.name,
                        href: meta.links.group_show,
                    },
                    {
                        name: $tc('messages.adaptations', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <PageSectionCollapsible is-open>
            <template v-slot:title>
                {{ $t('messages.explanation') }}
            </template>
            <div class="">
                <p class="mt-1 whitespace-pre-line col-span-8">
                    {{ $t('messages.student_adaptation_explanation') }}
                </p>
            </div>
        </PageSectionCollapsible>

        <div class="mt-5">
            <ul>
                <li v-for="student in students" :key="student.id" class="flex items-center gap-2 mt-1">
                    <StudentInfoItem :student="student" />

                    <span
                        v-if="student.subject_adaptations_count"
                        :title="`${student.subject_adaptations_count} ${$tc('messages.adaptations', student.subject_adaptations_count)}`"
                    >
                        ({{ student.subject_adaptations_count }})
                    </span>

                    <InertiaSquareLinkButton action="edit" :href="student.links.adaptations_edit" />
                </li>
            </ul>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import StudentInfoItem from '../../../../../components/StudentInfoItem.vue';
import InertiaSquareLinkButton from '../../../../../components/InertiaSquareLinkButton.vue';
import PageSectionCollapsible from '../../../../../Shared/PageSectionCollapsible.vue';

export default {
    components: {
        PageSectionCollapsible,
        InertiaSquareLinkButton,
        StudentInfoItem,
        PanelPage,
    },
    layout: Layout,
    name: 'Edit',
    props: ['meta', 'students', 'group'],
};
</script>
